const shoppingCartDictEN = {
  productType: "Product type:",
  soldBy: "Sold by",
  pickUpInStore: "Pick up in store",
  orderResume: "Order Summary",
  shippingOptions: "Shipping options",
  checkCatalog: "Check our offers",
  emptyCartText: "Your shopping cart is empty.",
  emptyCartSuggestion: "Access our store and see all the advantages that Extraconomy can offer.",
  percentualCreditInfo: "Percentage credit information",
  shop: "Shop",
  searchProducts: "Search products...",
  searchByTitleInThisSubcategory: "Search in this subcategory...",
  byCap: "By",
  product: "Product",
  noResultsFound: "No results found.",
  shoppingCart: "Shopping cart",
  cart: "Cart",
  subtotal: "Subtotal",
  onlyOneSeller: "You can only buy products from one seller.",
  items: "items",
  platformFee: "Platform fee",
  total: "Total",
  walletBalance: "Your current wallet balance",
  amountToPayWithWalletBalance: "Pay with your wallet balance",
  amountToPayWithExtracredit: "Pay with Extracredit",
  sendYourTransferReceipt: "Send your transfer receipt here",
  youWillNeedToTransfer: "You will need to transfer",
  toTheBankAccount: "to the bank account",
  andUploadTheReceipt: "and upload the receipt",
  finishOrder: "Finish order",
  finish: "Finish",
  goToPayment: "Go to payment",
  searching: "Searching",
  inSubcategory: "in subcategory",
  inAllProducts: "in all products",
  productMaximumExtracoinPercent: "Maximum Extracredit percentage (Product)",
  userMaximumExtracoinPercent: "Maximum Extracredit percentage (User)",
  checkout: "Checkout",
  amountToPayAtCheckout: "Amount to pay at checkout",
  orderData: "Order data",
  howWillPay: "How you will pay",
  otherMethods: "Other methods",
  creditRequested: "Credit requested",
  moreDetails: "more details",
  productNotFound: "Product not found. Try searching in our catalog.",
  downloadableAndNonDownloadable:
    "Downloadable and non-downloadable products can't be in the same cart.",
  balanceAvailable: "Extracredit balance available",
  freeExtracoinExplanation1: "As a newly-registered",
  freeExtracoinExplanation2:
    ", you'll be granted a full Extracredit payment for free in your first three orders, meaning you'll pay the minimum purchase amount without spending your Extracredit credits.",
  itemFavorited: "Item added to favorites.",
  itemRemovedFromFavorites: "Item removed from favorites.",
  info: "Info",
  searchForShipping: "Search shipping options for this mailing address",
  shippingQuotesFor: "Shipping quotes for",
  pleasePickASendMethod: 'Click the "Shipping options" button and then select a shipping method',
  shippingCost: "Shipping cost",
  searchAddress: "Auto Fill with ZIP Code",
  shippingResponsibilitySeller: "Shipping is the responsibility of the seller",
  plataformFeeExplanation: "The platform fee is 5% of the total value of the products.",
  cashbackExplanation:
    "Any amount that is not paid in extracredit will have 50% of it converted into cashback, returning to your wallet in extracredit.",
  thankYouForYourPurchase: "Thank you for your purchase",
  pleaseFillAllFieldsAddressOrSearchShippingMethod:
    "Please fill in all address fields or click on shipping options.",
  deliveryAddress: "Delivery address",
  pickUpAddress: "Pick up your order at",
  orderId: "Order ID",
  orderDate: "Order Date",
  orderTotal: "Order Total",
  extraconomyExplain:
    "You have the flexibility to use your Extracredit balance and/or wallet balance to pay for your order. Choose below how much you'd like to use from each to complete your purchase.",
  orderInformation: "Order Information",
  goToMyShoppings: "Go to my purchases",
  errorDontHavePhoneNumber:
    "You do not have a registered phone number. Fill in your phone number and Country Phone Code to continue.",
  insufficientFunds: "insufficient funds",
  errorCheckout:
    "There was an error while finalizing your order. Please contact support via WhatsApp at the following number. And don't forget to provide them with the information below.",
  contactEmail: "Get in touch",
  yourOrderWillBeProcessed: "Your order will be processed once the transfer has been confirmed.",
  weWillNotifyYou: "We will notify you by e-mail after confirmation.",
  creditCardInfo: "Enter your credit card information",
  error: "Error",
  invalidCardDetails: "Fill in correctly your credit card details",
  confirmation: "Confirmation",
  youDontHaveAddress: "You don't have an address registered",
  paymentFinished: "Payment completed successfully!",
  yourOrderWillBeReady: "Your order will be confirmed as soon as we receive your payment.",
  paymentDone: "Payment done",
  orderDetailsCart: "Order details",
  someItensMightBeDeliveredSeparately: "Some items might be delivered separately.",
  invoiceAddress: "Invoice address",
  shipToMyAddress: "Ship to my address",
  paypalPayment: "Pay with paypal or directly in your wallet",
  myCredits: "My credits",
  itemsRemoved: "Item removed from cart",
  combinePaymentMethods: "Combine 2 or more payment methods",
  combinePaymentExplanation:
    "You can combine more than one payment method to complete your purchase.",
  selectPaymentMethod: "Select payment method",
  paymentTermsAcceptance:
    "By clicking Pay, you accept our general terms of use and the general terms of sale of our merchants.",
  payWithExtracreditAndWallet: "Pay with extracredit and wallet balance",
  payWithBankTransfer: "Pay with bank transfer",
  payWithCreditCard: "Pay with credit card",
  payWithPayPal: "Pay your purchase with PayPal",
  continueShopping: "Continue shopping",
  afterTransferUploadReceipt: "After making the transfer, you must upload the receipt below.",
  uploadReceipt: "Upload receipt",
  receiptUploadedSuccessfully: "Receipt uploaded successfully!",
  removeReceipt: "Remove receipt",
  bankTransferImportantNote:
    "Important: bank transfer payments are not processed automatically. Our team will verify to ensure transaction security.",
  paymentWithExtracredit: "Payment with Extracredit",
  toBeUsed: "to be used",
  paymentWithWallet: "Payment with Wallet Balance",
  paymentCombination: "Payment Combination",
  paymentCombinationExplanation:
    "You can combine the values of extracredit and wallet balance to complete your payment. The total value must be equal to the purchase value.",
  paymentCompleteWithOtherMethods: "Payment complete with other methods",
  paymentCompleteWithOtherMethodsExplanation:
    "The total amount has already been covered by the other selected payment methods.",
  totalAlreadyCovered: "Total already covered",
  methodNotAvailable: "Method not available",
  methodNotAvailableExplanation: "This payment method is not available at the moment.",
  noWalletBalanceAvailable: "You don't have available wallet balance",
  walletBalanceRequired: "To use this payment method, you need to have balance in your wallet.",
  insufficientWalletBalance: "Insufficient balance",
  insufficientWalletBalanceMessage:
    "Your balance of {currency} {amount} is not sufficient to pay the total amount of {currency} {total}. Choose another payment method or enable the combine payments mode.",
  noExtracreditAvailable: "You don't have available extracredit",
  extracreditRequired: "To use this payment method, you need to have balance in your extracredit.",
  insufficientExtracredit: "Insufficient balance",
  insufficientExtracreditMessage:
    "Your balance of {currency} {amount} is not sufficient to pay the total amount of {currency} {total}. Choose another payment method or enable the combine payments mode.",
  extracreditAmountDescription: "Enter an amount that will be used from your extracredit balance.",
  walletAmountDescription: "Enter an amount that will be used from your wallet balance.",
  modify: "Modify",
  freight: "Freight",
  free: "Free",
  lookingTheBestShippingMethod: "We are looking for the best shipping method",
  processingPayment: "Processing payment...",
  userInfoDialogTitle: "User information",
  userInfoDialogDescription:
    "To continue with checkout, we need you to fill in some mandatory information.",
  requiredUserInfo: "Billing data",
  fillRequiredUserInfo: "Fill in required information",
  fillRequiredUserInfoDescription:
    "You need to fill in some mandatory information to continue with checkout (full name, phone and identification document).",
  firstName: "First name",
  lastName: "Last name",
  surname: "Last name",
  phone: "Phone",
  invalidPhoneNumber: "Invalid phone number",
  documentType: "Document type",
  enterYourFirstName: "Enter your first name",
  enterYourLastName: "Enter your last name",
};

export default shoppingCartDictEN;
